var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 5.25C2.48122 5.25 1.25 6.48122 1.25 8V17C1.25 18.5188 2.48122 19.75 4 19.75H20C21.5188 19.75 22.75 18.5188 22.75 17V8C22.75 6.48122 21.5188 5.25 20 5.25H4ZM2.79297 7.67389C2.93641 7.14167 3.42246 6.75 4 6.75H20C20.5775 6.75 21.0636 7.14168 21.207 7.67391L12.7809 14.4148C12.3244 14.7801 11.6757 14.7801 11.2191 14.4148L2.79297 7.67389ZM2.75 9.56045V17C2.75 17.6904 3.30964 18.25 4 18.25H20C20.6904 18.25 21.25 17.6904 21.25 17V9.56048L13.7179 15.5861C12.7136 16.3896 11.2865 16.3896 10.2821 15.5861L2.75 9.56045Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/Envelope.d6a44e3f0a7118a9324dc89015aa70c2.svg";
export { ForwardRef as ReactComponent };